import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { AvailabilityBlock, roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateAvailability(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<AvailabilityBlock>>({
    queryKey: roomRateAvailabilityQueryKeys.detail(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () => (await ReservationService.getAvailability(propertyId, roomTypeId, roomRateId)).result ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
